module.exports = __webpack_public_path__ + "static/netflix_737x729-baddfc29bfd6fdb11ebe36a71028ebfa.png";